import Const from 'constants';

const defaultStateData = {
    isAllowed: false,
    pitchersQuantity: {
        min: 0,
        max: 4,
    },
};

const defaultState = {
    data: cp(defaultStateData),
    isAllowed() {
        return this.data.isAllowed;
    },
    getPitchersQuantity(boundaryName) {
        return this.data.pitchersQuantity[boundaryName];
    },
    all() {
        return {...this.data};
    },
};

export default function (state = defaultState, action) {
    state = {...state};

    if (action.type === Const.OPPOSING_PITCHERS_SET_DATA_FROM_STORAGE) {
        const data = action.data;

        state = {
            ...defaultState,
            data,
        };
    } else if (action.type === Const.OPPOSING_PITCHERS_SET_IS_ALLOWED) {
        state.data.isAllowed = action.isAllowed;
    } else if (action.type === Const.OPPOSING_PITCHERS_SET_ALLOWED_QUANTITY) {
        state.data.pitchersQuantity[action.boundaryName] = action.quantity;
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {
            ...defaultState,
            data: cp(defaultStateData),
        };
    }

    return state;
}
